
let screenHeight = window.screen.height;
const setScrollAttr = () => {
    const scrollY = window.scrollY;
    const $documentEl = document.documentElement;
    const pageScrolledClass = 'page-scrolled';
    const ButtonScrollToTopClass = 'scroll-to-top-visible';
    $documentEl.dataset.scroll = scrollY;
    if (scrollY > 80) {
        $documentEl.classList.add(pageScrolledClass);
    }
    else {
        $documentEl.classList.remove(pageScrolledClass);
    }
    if (scrollY > (screenHeight + 60)) {
        $documentEl.classList.add(ButtonScrollToTopClass);
    }
    else {
        $documentEl.classList.remove(ButtonScrollToTopClass);
    }
}


const initScrollTopButton = () => {
    const scrollToTopButton = document.getElementById('pnScrollTop');
    if (scrollToTopButton) {
        scrollToTopButton.addEventListener('click', () => {
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        });
    }
};

ready(function () {
    setScrollAttr();
    initScrollTopButton();
    screenHeight = window.screen.height;
});
// Uncomment if we want to listen to scrolled window
document.addEventListener('scroll', () => {
    setScrollAttr();
});

function ready(callbackFunc) {
    if (document.readyState !== 'loading') {
        // Document is already ready, call the callback directly
        callbackFunc();
    } else if (document.addEventListener) {
        // All modern browsers to register DOMContentLoaded
        document.addEventListener('DOMContentLoaded', callbackFunc);

    } else {
        // Old IE browsers
        document.attachEvent('onreadystatechange', function () {
            if (document.readyState === 'complete') {
                callbackFunc();
            }
        });
    }
}

// Polyfills
// -----------------

// replaceAll
if (!String.prototype.replaceAll) {
    String.prototype.replaceAll = function (str, newStr) {

        // If a regex pattern
        if (Object.prototype.toString.call(str).toLowerCase() === '[object regexp]') {
            return this.replace(str, newStr);
        }

        // If a string
        return this.replace(new RegExp(str, 'g'), newStr);

    };
}